import { useEffect, useState } from "react";
import { api, brl } from "@/lib/api";
import { TopBar } from "@/components/Shell";

export default function MerchantFinance() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/merchant/finance").then(({ data }) => setF(data)).catch(() => {}); }, []);
  if (!f) return <div className="p-6 text-sm text-gray-500">Carregando financeiro…</div>;

  return (
    <div data-testid="merchant-finance-page">
      <TopBar subtitle="Financeiro e repasses" />
      <div className="px-4 pt-5">
        <h1 className="font-display text-2xl font-extrabold">Financeiro</h1>

        <div className="grid grid-cols-2 gap-3 mt-4">
          <Box testId="finance-to-receive" label="Total a receber" value={brl(f.to_receive)} accent />
          <Box testId="finance-already-paid" label="Repasses pagos" value={brl(f.already_paid)} />
          <Box testId="finance-platform-total" label="Taxa Time Food" value={brl(f.total_platform_fee)} />
          <Box testId="finance-municipal-total" label="Taxa Prefeitura" value={brl(f.total_municipal_fee)} />
        </div>

        <h2 className="font-display font-bold text-lg mt-7">Extrato por pedido</h2>
        <div className="mt-3 grid gap-2" data-testid="finance-statements">
          {f.statements.map((s) => (
            <div key={s.order_id} className="rounded-2xl border border-gray-200 p-3.5 bg-white">
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-semibold text-sm">{s.code}</p>
                  <p className="text-[11px] text-gray-500">{new Date(s.created_at).toLocaleDateString("pt-BR")}</p>
                </div>
                <span
                  className="text-[10px] font-bold px-2 py-1 rounded-full text-white"
                  style={{ background: s.paid_out ? "#2E8B57" : "#FF7A1A" }}
                >
                  {s.paid_out ? "Repassado" : "A receber"}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-y-1 mt-2 text-[11px]">
                <span className="text-gray-500">Valor bruto</span><span className="text-right font-semibold">{brl(s.gross)}</span>
                <span className="text-gray-500">Taxa Prefeitura (3,5%)</span><span className="text-right text-mage-navy">- {brl(s.municipal_fee)}</span>
                <span className="text-gray-500">Time Food (2,5% + serviço)</span><span className="text-right text-mage-red">- {brl(s.platform_fee)}</span>
                <span className="text-gray-500">Indicações (nível 1 + 2)</span><span className="text-right text-gray-600">- {brl(s.ref_l1_fee + s.ref_l2_fee)}</span>
                <span className="font-bold text-gf-black">Líquido recebido</span>
                <span className="text-right font-display font-extrabold text-mage-green">{brl(s.net)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const Box = ({ label, value, accent, testId }) => (
  <div data-testid={testId} className="rounded-2xl border p-4 bg-white" style={{ borderColor: accent ? "#FF7A1A" : "#E5E7EB" }}>
    <p className="text-[11px] text-gray-500">{label}</p>
    <p className="font-display text-lg font-extrabold">{value}</p>
  </div>
);
